import { render, staticRenderFns } from "./DeleteVendor.vue?vue&type=template&id=7c2b22f2&"
import script from "./DeleteVendor.vue?vue&type=script&lang=js&"
export * from "./DeleteVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports